export default {
  invalidEmail: "Ungültige E-Mail-Adresse",
  passwordRequired: "Passwort ist erforderlich",
  invalidLogin:
    "E-Mail oder Passwort falsch. Versuchen Sie es erneut oder nutzen Sie „Passwort vergessen“, wenn Sie es zurücksetzen möchten.",
  accountDisabled:
    "Dieses Konto wurde deaktiviert. Kontaktieren Sie den Support, wenn Sie Hilfe benötigen.",
  kioskRevoked:
    "Dieser Tablet-Zugang wurde widerrufen. Bitten Sie Ihren Standort-Administrator um neue Zugangsdaten.",
  softwareIdRequired:
    "Diese Anmeldung benötigt eine Gerätekennung. Nutzen Sie den QR-Anmeldeablauf von Ihrem Standortgerät oder kontaktieren Sie den Support.",
  loginSuccess: "Anmeldung erfolgreich!",
  partnerPortal: "Verkäufer-Portal",
  heroTitleLine1: "Verwalten Sie Ihr",
  heroTitleLine2: "Geschäft mit Leichtigkeit",
  heroSubtitle:
    "Das dedizierte Portal für Verkäufer zur Verwaltung von Buchungen, Aktivitäten und Einnahmen an einem Ort.",
  statPartners: "Aktive Verkäufer",
  statBookings: "Buchungen/Monat",
  welcomeBack: "Willkommen zurück!",
  signInSubtitle: "Melden Sie sich an, um fortzufahren",
  email: "E-Mail",
  emailPlaceholder: "name@beispiel.de",
  password: "Passwort",
  passwordPlaceholder: "••••••••",
  showPassword: "Passwort anzeigen",
  hidePassword: "Passwort ausblenden",
  showConfirmPassword: "Bestätigungspasswort anzeigen",
  hideConfirmPassword: "Bestätigungspasswort ausblenden",
  signIn: "Anmelden",
  forgotPasswordLink: "Passwort vergessen?",
  forgotPasswordTitle: "Passwort vergessen",
  forgotPasswordSubtitle:
    "Geben Sie Ihre Konto-E-Mail ein. Wenn sie einem Verkäufer-Portal-Konto entspricht, senden wir einen Link zum Zurücksetzen.",
  forgotPasswordSubmit: "Link zum Zurücksetzen senden",
  forgotPasswordSuccessToast:
    "Wenn die Adresse gültig ist, prüfen Sie Ihren Posteingang.",
  forgotPasswordCheckEmail:
    "Wenn die Adresse gültig ist, haben wir Anweisungen an Ihren Posteingang gesendet.",
  forgotPasswordRulesReminder:
    "Neue Passwörter müssen mindestens {{min}} Zeichen haben und Groß- und Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.",
  setPasswordTitle: "Passwort festlegen",
  setPasswordChecking: "Link wird geprüft…",
  setPasswordInvalidLink:
    "Dieser Link ist ungültig oder abgelaufen. Bitten Sie Staff um eine neue Einladung oder fordern Sie auf der Anmeldeseite ein Passwort-Reset an.",
  setPasswordRequirementsTitle: "Passwortanforderungen",
  setPasswordRequirementMinLength: "Mindestens {{min}} Zeichen",
  setPasswordRequirementMixedCase: "Groß- und Kleinbuchstaben (A–z)",
  setPasswordRequirementDigit: "Mindestens eine Zahl",
  setPasswordRequirementSpecial: "Mindestens ein Sonderzeichen (z. B. ! @ #)",
  setPasswordTooCommonToast:
    "Dieses Passwort ist zu leicht zu erraten. Wählen Sie ein stärkeres, weniger verbreitetes Passwort.",
  setPasswordSubmit: "Passwort speichern",
  setPasswordSuccessToast:
    "Ihr Passwort wurde festgelegt. Sie können sich jetzt anmelden.",
  setPasswordDone:
    "Ihr Passwort wurde gespeichert. Sie können diese Seite schließen und sich anmelden.",
  newPassword: "Neues Passwort",
  confirmPassword: "Passwort bestätigen",
  passwordConfirmRequired: "Bitte bestätigen Sie Ihr Passwort",
  passwordsDoNotMatch: "Passwörter stimmen nicht überein",
  setPasswordMinLength: "Passwort muss mindestens {{min}} Zeichen haben",
  setPasswordMixedCase: "Groß- und Kleinbuchstaben einschließen (A–z)",
  setPasswordRequireDigit: "Mindestens eine Zahl einschließen",
  setPasswordRequireSpecial:
    "Mindestens ein Sonderzeichen einschließen (z. B. ! @ #)",
  backToLogin: "Zurück zur Anmeldung",
  testCredentialsTitle: "Test-Zugangsdaten",
} as const;
